import { useQuery } from '@tanstack/react-query';

import { apiClient } from '@services/apiClient';

export const historyByAIKey = (actionItemId) => ['historyByAI', actionItemId];
export const historyByAIFn = ({ queryKey }) =>
  apiClient.get(`${APP_API_URL}history-by-action-item/${queryKey[1]}`);

export const useHistoryByAIQuery = ({ actionItemId, equipmentId }) => {
  return useQuery({
    queryKey: historyByAIKey(actionItemId),
    queryFn: historyByAIFn,
    enabled: !!actionItemId && !equipmentId,
    select: ({ data }) => data?.list || [],
  });
};
